import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';


const TutorialLink = ({data}) => {
    if (!data) return;
    const anchorScroll = (e, id) => {
        e.preventDefault();
        const target = root.document.getElementById(id);
        target.scrollIntoView({behavior: 'smooth'})
    }

    return (
        <div className="quick-links-wrapper content-container">
            {
                data.map((item, i) => {
                    const {title, id, image} = item;
                    return (
                        <a href={`#${id}`} className="quick-links-box" key={`${id}-${i}`} onClick={(e) => anchorScroll(e, id)}>
                            <img src={image} alt={title}/>  
                            <div className="quick-links-content">
                                <h4>{title}</h4>
                                <p>{title}</p>
                            </div>
                        </a>
                    )
                })
            }
        </div>
    )
}

TutorialLink.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string,
            image: PropTypes.string
        })
    )
}

export default TutorialLink
